import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Properties API
export const propertiesApi = {
  getAll: async (status = null) => {
    const params = status ? { status } : {};
    const response = await axios.get(`${API}/properties`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/properties/${id}`);
    return response.data;
  },
  
  create: async (propertyData) => {
    const response = await axios.post(`${API}/properties`, propertyData);
    return response.data;
  },
  
  update: async (id, propertyData) => {
    const response = await axios.put(`${API}/properties/${id}`, propertyData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/properties/${id}`);
    return response.data;
  }
};

// Contact API
export const contactApi = {
  send: async (messageData) => {
    const response = await axios.post(`${API}/contact`, messageData);
    return response.data;
  },
  
  getAll: async () => {
    const response = await axios.get(`${API}/contact`);
    return response.data;
  },
  
  markAsRead: async (id) => {
    const response = await axios.put(`${API}/contact/${id}/read`);
    return response.data;
  }
};
